/* Home-2 redesign (V65). Event delegation on document, so sections re-rendered in the theme editor keep working. */
(() => {
  if (window.__nmh2) return;
  window.__nmh2 = true;

  /* Model finder: hero select, compare button and mobile sticky bar share one selected model.
     Nothing is preselected: until a model is chosen, the buttons focus a picker instead of navigating. */
  const setModel = (slug) => {
    document.querySelectorAll('[data-nmh2-model]').forEach((s) => { if (s.value !== slug) s.value = slug; });
    document.querySelectorAll('[data-nmh2-model-link]').forEach((a) => { a.href = (a.dataset.base || '/collections/') + slug; a.dataset.nmh2Ready = '1'; });
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-nmh2-model-link]');
    if (!a || a.dataset.nmh2Ready === '1') return;
    const any = document.querySelector('[data-nmh2-model]');
    if (!any || any.value) return; // no picker on the page, or a model is preselected in the theme editor
    e.preventDefault();
    const own = a.parentElement.querySelector('[data-nmh2-model]');
    const sel = own || document.querySelector('.nmh2-hero [data-nmh2-model]') || any;
    if (!own) sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    sel.focus({ preventScroll: !own });
    sel.classList.add('is-required');
    if (typeof sel.showPicker === 'function') { try { sel.showPicker(); } catch (_) { /* some browsers refuse without a direct gesture */ } }
  });
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-nmh2-model]');
    if (s && s.value) { setModel(s.value); document.querySelectorAll('[data-nmh2-model]').forEach((x) => x.classList.remove('is-required')); }
  });

  /* Scroll rows: arrows scroll 80% of the visible width. */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-nmh2-scroll]');
    if (!b) return;
    const row = document.getElementById(b.getAttribute('aria-controls'));
    if (row) row.scrollBy({ left: Number(b.dataset.nmh2Scroll) * row.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* Custom scroll indicator under the stories row. */
  const syncTrack = (row) => {
    const track = document.querySelector(`[data-nmh2-track="${row.id}"]`);
    if (!track) return;
    const thumb = track.querySelector('.nmh2-track__thumb');
    const w = Math.min(1, row.clientWidth / row.scrollWidth);
    const max = row.scrollWidth - row.clientWidth;
    const p = max > 0 ? row.scrollLeft / max : 0;
    thumb.style.width = `${w * 100}%`;
    thumb.style.left = `${p * (1 - w) * 100}%`;
  };
  document.addEventListener('scroll', (e) => {
    const row = e.target;
    if (row instanceof Element && row.matches('[data-nmh2-row]')) syncTrack(row);
  }, { capture: true, passive: true });
  document.addEventListener('click', (e) => {
    const hit = e.target.closest('[data-nmh2-track] .nmh2-track__hit');
    if (!hit) return;
    const row = document.getElementById(hit.parentElement.dataset.nmh2Track);
    if (!row) return;
    const r = hit.getBoundingClientRect();
    row.scrollTo({ left: ((e.clientX - r.left) / r.width) * (row.scrollWidth - row.clientWidth), behavior: 'smooth' });
  });
  const syncAll = () => document.querySelectorAll('[data-nmh2-row]').forEach(syncTrack);
  window.addEventListener('resize', syncAll);
  window.addEventListener('load', syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);

  /* Corduroy swatches: change the main photo, caption and colour name. */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-nmh2-swatch]');
    if (sw) {
      const root = sw.closest('[data-nmh2-cord]');
      const img = root.querySelector('[data-nmh2-cord-img]');
      img.srcset = sw.dataset.srcset || '';
      img.src = sw.dataset.src;
      img.alt = sw.dataset.caption;
      root.querySelector('[data-nmh2-cord-caption]').textContent = sw.dataset.caption;
      root.querySelector('[data-nmh2-cord-name]').textContent = sw.dataset.name;
      root.querySelectorAll('[data-nmh2-swatch]').forEach((b) => b.setAttribute('aria-pressed', String(b === sw)));
      return;
    }
    const more = e.target.closest('[data-nmh2-more]');
    if (more) {
      const root = more.closest('[data-nmh2-cord]');
      const open = more.getAttribute('aria-expanded') !== 'true';
      root.querySelectorAll('[data-nmh2-extra]').forEach((b) => { b.hidden = !open; });
      more.setAttribute('aria-expanded', String(open));
      more.textContent = open ? '−' : more.dataset.closedLabel;
    }
  });

  /* Before/after compare slider. */
  document.addEventListener('input', (e) => {
    const r = e.target.closest('[data-nmh2-compare-range]');
    if (r) r.closest('.nmh2-compare').style.setProperty('--pos', `${r.value}%`);
  });

  /* FAQ: one item open at a time; clicking the open one closes it. */
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-nmh2-faq-q]');
    if (!q) return;
    const list = q.closest('.nmh2-faq__list');
    const wasOpen = q.getAttribute('aria-expanded') === 'true';
    list.querySelectorAll('[data-nmh2-faq-q]').forEach((b) => {
      const open = b === q && !wasOpen;
      b.setAttribute('aria-expanded', String(open));
      b.querySelector('.nmh2-faq__sign').textContent = open ? '−' : '+';
      document.getElementById(b.getAttribute('aria-controls')).hidden = !open;
    });
  });

  /* Mobile sticky finder: visible after scrolling 640px, on screens under 640px wide. */
  let ticking = false;
  const syncSticky = () => {
    ticking = false;
    const bar = document.querySelector('[data-nmh2-sticky]');
    if (bar) bar.classList.toggle('is-visible', window.scrollY > 640 && window.innerWidth < 640);
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); } }, { passive: true });
  window.addEventListener('resize', syncSticky);
})();
